import { createSlice } from '@reduxjs/toolkit';
import { Offer, GetAmountPerPaycheck } from 'api/ReportsApi';
import { GoalProgress, NextStep } from 'api/AICoachGoalsApi';
import { getOffers, getAmountPerPaycheck, getGoalProgress, getNextSteps } from 'thunks';

export interface ReportsState {
  offers: Offer[];
  amountPerPaycheck: GetAmountPerPaycheck | null;
  goalProgress: GoalProgress | null;
  nextSteps: NextStep[];
  isLoading: boolean;
  isAmountPerPaycheckLoading: boolean;
  isGoalProgressLoading: boolean;
  isNextStepsLoading: boolean;
  isError: boolean;
  isAmountPerPaycheckError: boolean;
  isGoalProgressError: boolean;
  isNextStepsError: boolean;
}

const initialState: ReportsState = {
  offers: [],
  amountPerPaycheck: null,
  goalProgress: null,
  nextSteps: [],
  isLoading: false,
  isAmountPerPaycheckLoading: false,
  isGoalProgressLoading: false,
  isNextStepsLoading: false,
  isError: false,
  isAmountPerPaycheckError: false,
  isGoalProgressError: false,
  isNextStepsError: false,
};

const reports = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOffers.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(getOffers.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.isError = false;
      state.offers = payload;
    });

    builder.addCase(getOffers.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    builder.addCase(getAmountPerPaycheck.pending, (state) => {
      state.isAmountPerPaycheckLoading = true;
      state.isAmountPerPaycheckError = false;
    });

    builder.addCase(getAmountPerPaycheck.fulfilled, (state, { payload }) => {
      state.isAmountPerPaycheckLoading = false;
      state.isAmountPerPaycheckError = false;
      state.amountPerPaycheck = payload;
    });

    builder.addCase(getAmountPerPaycheck.rejected, (state) => {
      state.isAmountPerPaycheckLoading = false;
      state.isAmountPerPaycheckError = true;
    });

    builder.addCase(getGoalProgress.pending, (state) => {
      state.isGoalProgressLoading = true;
      state.isGoalProgressError = false;
    });

    builder.addCase(getGoalProgress.fulfilled, (state, { payload }) => {
      state.isGoalProgressLoading = false;
      state.goalProgress = payload;
    });

    builder.addCase(getGoalProgress.rejected, (state) => {
      state.isGoalProgressLoading = false;
      state.isGoalProgressError = true;
    });

    builder.addCase(getNextSteps.pending, (state) => {
      state.isNextStepsLoading = true;
      state.isNextStepsError = false;
    });

    builder.addCase(getNextSteps.fulfilled, (state, { payload }) => {
      state.isNextStepsLoading = false;
      state.nextSteps = payload;
    });

    builder.addCase(getNextSteps.rejected, (state) => {
      state.isNextStepsLoading = false;
      state.isNextStepsError = true;
    });
  },
});

export default reports.reducer;
